import React from "react";
import styles from "./ResourceCard.module.scss";
import PlaceHolder from "../../../../static/images/imagePlaceholder.svg";

export const ResourceCard = ({ resource, onClick, disabled = false }) => {
  const { key, icon, label } = resource;

  const handleClick = () => {
    if (disabled) return;
    onClick?.(key);
  };

  return (
    <div
      className={`${styles.resource_card} ${disabled ? styles.resource_card_disabled : ""}`}
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      onClick={handleClick}
      onKeyDown={(e) => !disabled && (e.key === "Enter" || e.key === " ") && handleClick()}
    >
      <div className={styles.leftpanel}>
        <div className={styles.resource_card_image_wrapper}>
          <img src={icon || PlaceHolder} alt={label} className={styles.resource_image} loading="lazy" />
        </div>
        <div className={styles.resource_content}>
          <div className={styles.resource_label}>{label}</div>
        </div>
      </div>
      {
        <span className={styles.resource_chevron} aria-hidden="true">
          ›
        </span>
      }
    </div>
  );
};
